<template>
    <div @click="openNotification" role="button" class="notification border m-1 p-1" style="cursor: pointer"
         :class="{'unread': !item.read_at}">
        <div class="d-flex justify-content-between">
            <div class="mr-1">
                <i class="fas fa-info-circle text-info text-lg"></i>
            </div>
            <div class="flex-grow-1">
                <strong>{{ item.title }}</strong>
                <br>
                <div class="clearfix">{{ item.description }}</div>
                <small class="float-left">
                    <i class="fas fa-clock"></i> {{ moment(item.created_at).fromNow() }}
                </small>
                <small class="float-right" v-if="item.read_at" :title="'Read ' + moment(item.read_at).fromNow()"><i class="fas fa-check text-success"></i></small>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: ['item'],
    data() {
        return {}
    },
    methods: {
        moment,
        openNotification() {
            if (!this.item.read_at) {
                this.$store.dispatch('notification/markItemRead', this.item.id);
            }
            let link = '';
            if (/^TICKET_.+/.test(this.item.type)) {
                link = '/complaints?ticket=' + this.item.data.ticket_no + '&time=' + Date.now();
            }
            if (link) {
                this.$router.push(link);
            }
        },
    }
}
</script>
<style>
.notification {
    border-radius: .5rem;
    padding: 1rem;
}

.unread {
    background: #e3e7ec;
}
</style>
